// extracted by mini-css-extract-plugin
export default {"footerBackgroundParent":"Sermons_footerBackgroundParent__0SUBf","sermons":"Sermons_sermons__HYuiD"};